var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/results.template.html');

var EconomicalTechnicalView = require('views/results/economical_technical.results.view.ts');
var PVBuildingView = require('views/results/pv_building.results.view.ts');
var PdfView = require('views/pdf/pdf.view.ts');

var TheView = GenericView.extend({
    el: '#results',
    tagName: '',
	template: Handlebars.compile(Template),
	frontEndData: null,
	outputData: null,
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
      "click .ui-tabview__container__nav.results .nav-item-inside": "changeTab",
      "click #resultsB": "showResults",
      "click #clearData": "clearData",
      "click #staticDataB": "loadStaticData",
      "click #exportResultsPdf": "createPdfFile",
      "click #exportResultsExcel": "downloadExcelFile",
    },
    changeTab: function(event) {
      event.stopPropagation();
      this.$el.find(".ui-tabview__container__nav.results").find("li.active").removeClass("active");
      $(event.currentTarget).addClass("active");

      this.$el.find(".ui-tabview__panels.results > .show").removeClass("show");
      var id = $(event.currentTarget).data("id");
      $("#" + id).addClass("show");

    },
    renderTabsContent: function(response) {
        var economical_technical_view = new EconomicalTechnicalView({"data": response});
        var pv_building_view = new PVBuildingView({"data": response});
    },
    showResults: function() {
        var self = this;

        //show loader and disabled buttons
        $("#response").text("");
        $("#results-loader").show();
        $("#resultsB").prop('disabled', true);
        $("#staticDataB").prop('disabled', true);

        var has_error = this.validateAll();

        if (has_error == true) {
            $("#resultsB").notify("Some of your inputs are invalid. Please check the corresponding fields with an error message underneath them.", { className: "error", position: "bottom center" });
            $("#results-loader").hide();
            $("#resultsB").prop('disabled', false);
            $("#staticDataB").prop('disabled', false);
        } else {

            this.frontEndData = this.createJson();
            $.ajax({
                url: "api/calculations",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(self.frontEndData),
            }).done(function(response) {
                //clear or errors if exists
                var errors = $('body').find(".has-error");
                GenericView.prototype.clearAllErrors(errors);

                self.outputData = response;

                //hide loader and buttons
                $("#results-loader").hide();
                $("#resultsB").prop('disabled', false);
                $("#staticDataB").prop('disabled', false);
                $(".resultsB-container").hide();
                $(".results-container").show();
console.log(response);
                var pdf_view = new PdfView(response);
                self.renderTabsContent(response, self.frontEndData);
            }).fail(function(resp, xhr, errorMessage) {
                //hide loader and allow buttons
                $("#results-loader").hide();
                $("#resultsB").prop('disabled', false);
                $("#staticDataB").prop('disabled', false);

                if(resp.status == 502) {
                    $("#response").text("Server is down or under maintenance");
                }
                else if(resp.status == 500) {
                    $("#response").html("There was an error with the calculation. Please check the data that you have inserted.<br/>Code: "+ resp.status);
                }
                else {
                    $("#response").html("Server Error<br/>Code: "+ resp.status);
                }
                console.error("resp: ", resp);
                console.error("xhr: ", xhr);
                console.error("status: ", errorMessage);
            });
        }

    },
    clearData: function() {
        $(".resultsB-container").show();
        $(".results-container").hide();
        this.outputData = null;
    },
    loadStaticData: function() {
        var analysis_method = $("input[name='analysis_method']:checked").val();
        if ( analysis_method == "EXHAUSTIVE_ANALYSIS" ) {
            var static_data = window.outputDataExhaustive;
        } else {
            var static_data = window.outputDataOther;
        }
        var pdf_view = new PdfView(static_data);
        this.renderTabsContent(static_data);
        $(".resultsB-container").hide();
        $(".results-container").show();
    },
    validateAll: function() {
        var has_error = false;
        var fields = $('body').find(".to-validation input");
        var tempFieldsForValidation = [];
        var fieldsForValidation = [];

        var consumptionSelectValue = $('#select-type-energy').val();
        if ( $('#' + consumptionSelectValue + ' .flexibility').hasClass('noValidation') ) {
            $.grep(fields, function(el) {

                if (el.classList.contains('timeOfUsage') == false) {
                    tempFieldsForValidation.push(el);
                }
            })
        } else {
            tempFieldsForValidation = fields;
        }

        if ( $('#charges .zonal').hasClass('to-validation') && $('#zoneC').prop('checked') == false ) {
             $.grep(tempFieldsForValidation, function(el) {

                if (el.classList.contains('zoneC') == false) {
                    fieldsForValidation.push(el);
                }
            })
        } else {
            fieldsForValidation = tempFieldsForValidation;
        }

        has_error = GenericView.prototype.validateFields(fieldsForValidation);
        return has_error;
    },
    createJson: function() {
        var views = GenericView.prototype.views;

        var pv_system = views["pv_system"].getAllData();
        var battery_energy = views["battery_energy"].getAllData();
        var charges = views["electricity_charges"].getAllData();
        var policy = views["policy"].getAllData();
        var financial = views["financial"].getAllData();
        var analysis = views["analysis"].getAllData();

        var flexibility = null;
        if ( $("#select-type-energy").val() == "monthly" )
            flexibility = views["monthly"].getAllData();
        else if ( $("#select-type-energy").val() == "yearly" )
            flexibility = views["yearly"].getAllData();
        else if ( $("#select-type-energy").val() == "customized" )
            flexibility = views["customized"].getAllData();

        financial['lifecycles'] = battery_energy.lifecycles;
        analysis['bat_cost_decr'] = financial.bat_cost_decr;
        delete financial.bat_cost_decr;

        var data = {
            "pvSystem": pv_system,
            "bessData": battery_energy,
            "flexibility": flexibility,
            "ecPostData": charges,
            "policy": policy,
            "financial": financial,
            "analysisOptions": analysis
        };
console.log(JSON.stringify(data));
        return data;
    },
    createPdfFile: function() {
        var self = this;
        var section = "";
        var analysis_method = $("input[name='analysis_method']:checked").val();

        if (this.outputData != null) {
            var years = [];
            $.each( self.outputData.cashFlows.cashFlowsIn, function( index, value ) {
              years.push(index+1);
            });

            GenericView.prototype.createBarChart('figure1', 'Monthly SCR (%)', '', '', self.outputData.tableSCR, [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
            GenericView.prototype.createBarChart('figure2', 'Monthly SSR (%)', '', '', self.outputData.tableSSR, [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
            GenericView.prototype.createBarChart('figure3', 'Cash flow (€)', '', '', self.outputData.cashFlows.cashFlowsIn, self.outputData.cashFlows.cashFlowsOut, years, 'CashInFlows', 'CashOutFlows', '#4472c4', '#ed7d31', true);
            if ( analysis_method == "INCREASED_SSR_NPV" )
                this.cashEffective();
        } else {
            GenericView.prototype.createBarChart('figure1', 'Monthly SCR (%)', '', '', [95,94,92,90,52,54,58,65,72,91,94,95], [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
            GenericView.prototype.createBarChart('figure2', 'Monthly SSR (%)', '', '', [32,48,60,75,94,99,93,80,79,58,42,28], [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
            GenericView.prototype.createBarChart('figure3', 'Cash flow (€)', '', '', [750,760,780,790,800,810,820,830,840,850,860,900,910,920,930,940,960,1000,1020,1040], [90,100,110,110,120,120,130,130,140,140,150,150,160,160,170,170,180,180,190,190], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], 'CashInFlows', 'CashOutFlows', '#4472c4', '#ed7d31', true);
        }

        $("#pdf-loader").show();
        $("#exportResults").css("right","40px");

        if ( analysis_method == "EXHAUSTIVE_ANALYSIS" ) {
            $("#pdf-section").find(".exhaustive").show();
            section = ".exhaustive";
        } else if ( analysis_method == "INCREASED_SSR_NPV" ) {
            $("#pdf-section").find(".max").show();
            $("#pdf-section").find(".ssr").show();
            section = ".max";
            section2 = ".ssr";
        } else {
            $("#pdf-section").find(".max").show();
            section = ".max";
        }

        $('html, body').css({
            overflow: 'hidden',
            height: '100%'
        });

        var doc = new jsPDF('p', 'pt', 'a4', true/*[PDF_Width, PDF_Height]*/);

        setTimeout(function() {
            html2canvas(document.querySelector("#pdf-section " + section + " .part1"), {
                allowTaint: true,
                scale: 2
            }).then(canvas => {
                canvas.getContext('2d');
                var img = canvas.toDataURL("image/png");
                const imgProps= doc.getImageProperties(img);
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                doc.addImage(img, 'PNG', 15, 15, pdfWidth, pdfHeight,'','FAST');
            });
        }, 1000);

        setTimeout(function() {
            html2canvas(document.querySelector("#pdf-section " + section + " .part2"), {
                allowTaint: true,
                scale: 2
            }).then(canvas => {
                canvas.getContext('2d');
                var img = canvas.toDataURL("image/png");
                const imgProps= doc.getImageProperties(img);
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                doc.addPage();
                doc.addImage(img, 'PNG', 15, 15, pdfWidth, pdfHeight,'','FAST');
            });
        }, 1000);

        setTimeout(function() {
            html2canvas(document.querySelector("#pdf-section " + section + " .part3"), {
                allowTaint: true,
                scale: 2
            }).then(canvas => {
                canvas.getContext('2d');
                var img = canvas.toDataURL("image/png");
                const imgProps= doc.getImageProperties(img);
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                doc.addPage();
                doc.addImage(img, 'PNG', 15, 15, pdfWidth, pdfHeight,'','FAST');
            });
        }, 1000);

        if ( analysis_method == "INCREASED_SSR_NPV" ) {
            setTimeout(function() {
                html2canvas(document.querySelector("#pdf-section " + section2 + " .part2"), {
                    allowTaint: true,
                    scale: 2
                }).then(canvas => {
                    canvas.getContext('2d');
                    var img = canvas.toDataURL("image/png");
                    const imgProps= doc.getImageProperties(img);
                    const pdfWidth = doc.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                    doc.addPage();
                    doc.addImage(img, 'PNG', 15, 15, pdfWidth, pdfHeight,'','FAST');
                });
            }, 1000);
        }

        setTimeout(function() {
            doc.save("berlin-tool-export-data.pdf");
            $("#pdf-loader").hide();
            $("#exportResults").css("right","0");
            $("#pdf-section").hide();
            $('html, body').css({
                overflow: 'auto',
                height: 'auto'
            });

        }, 14000);

    },
    downloadExcelFile: function() {
        var zip = new JSZip();
        var count = 0;
        var zipFilename = "exportData.zip";

        var filepath1_url = this.outputData.filepath_economical_technical;
        var filepath2_url = this.outputData.filepath_gen_con;

        var urls = [
          filepath1_url,
          filepath2_url
        ];

        urls.forEach(function(url){
          var filename = "filename";
          // loading a file and add it in a zip file
          JSZipUtils.getBinaryContent(url, function (err, data) {
             if(err) {
                throw err; // or handle the error
             }
             zip.file(url, data, {binary:true});
             count++;
             if (count == urls.length) {
               zip.generateAsync({type:"blob"}).then(function (blob) {
                   saveAs(blob, zipFilename);
               });
             }
          });
        });
    },
    cashEffective: function() {
        var batterySize = this.outputData.tableToCompare[0];
        var pvSize = this.outputData.tableToCompare[1];
        var ssr = this.outputData.tableToCompare[2];
        var npv = this.outputData.tableToCompare[3];

        var data = [];
        for (var i=0; i<10; i++) {
            var temp = {x: ssr[i], y: npv[i]};
            data.push(temp);
        }

        var self = this;
        var ctx = document.getElementById('figure4').getContext('2d');

        var myChart = new Chart(ctx, {
            type: 'scatter',
            data: {
                datasets: [{
                    data: data,
                    battery: batterySize,
                    pv: pvSize,
                    borderColor: "#4472c4",
                    fill: false,
                }],
            },
            options: {
                responsive: true,
                aspectRatio: 3,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: 'Cost effective solutions',
                    fontSize: '20',
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: "SSR (%)"
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: "NPV (€)"
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: ()=>null,
                        title: ()=>null,
                        beforeFooter: function(item, everything) {
                            let index = item[0].index;

                            if (index >= 0) {
                                let battery_value = everything.datasets[0].battery[index];

                                return 'Battery = ' + battery_value + ' kWh';
                            } else {
                                return;
                            }
                        },
                        footer: function(item, everything) {
                            let index = item[0].index;

                            if (index >= 0) {
                                let pv_value = everything.datasets[0].pv[index];

                                return 'PV = ' + pv_value + ' kWp';
                            } else {
                                return;
                            }
                        }
                    }
                }
              }
        });

        myChart.canvas.parentNode.style.height = '350px';
        myChart.canvas.parentNode.style.width = '90%';
    },

});

module.exports= TheView;